import {createCommand, LexicalCommand} from 'lexical';

export const SAVE_EDITOR_COMMAND: LexicalCommand<undefined> = createCommand();
